var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addUserLabels.utenteLbl) + _vm._s(_vm.utenteConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.utenteConfigs
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utenteValue),
      expression: "utenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "utenteId"
    },
    domProps: {
      "value": (_vm.utenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utenteValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addUserLabels.nomeCognomeLbl) + _vm._s(_vm.nomeCognomeConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.nomeCognomeConfigs
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeCognomeValue),
      expression: "nomeCognomeValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "nomeCognomeId"
    },
    domProps: {
      "value": (_vm.nomeCognomeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeCognomeValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addUserLabels.eMailLbl) + _vm._s(_vm.eMailConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.eMailConfigs
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eMailValue),
      expression: "eMailValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "eMailId"
    },
    domProps: {
      "value": (_vm.eMailValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eMailValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addUserLabels.telefonoLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.telefonoConfigs
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telefonoValue),
      expression: "telefonoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "telefonoId"
    },
    domProps: {
      "value": (_vm.telefonoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telefonoValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addUserLabels.faxLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.faxConfigs
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faxValue),
      expression: "faxValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "faxId"
    },
    domProps: {
      "value": (_vm.faxValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faxValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "controls col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.addUserLabels.annullaBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.addUserLabels.confermaBtnLbl))])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e85ffa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/AddUser.vue
// module id = 1706
// module chunks = 1